import { Box, Typography } from '@mui/material';

/**
 * Consistent tab header. `kicker` is a small uppercase label (the
 * encounter section), `title` is the bold line, `hint` is a short
 * descriptor that helps non-technical clinicians understand what
 * lives in this tab.
 */
export default function SectionHeading({ kicker = 'Encounter', title, hint }) {
    return (
        <Box sx={{ mb: 2.5 }}>
            <Typography
                variant="overline"
                sx={{ color: 'text.secondary', letterSpacing: 1.2, fontWeight: 700, fontSize: 10 }}
            >
                {kicker}
            </Typography>
            <Typography variant="h6" sx={{ color: '#052F5D', fontWeight: 600, lineHeight: 1.2, mt: 0.25 }}>
                {title}
            </Typography>
            {hint && (
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                    {hint}
                </Typography>
            )}
        </Box>
    );
}
